import React from 'react';
import { MailIcon, GlobeIcon, InstagramIcon } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-[#0a0a0a] border-t border-purple-500/20 py-12 px-4" data-id="element-83">
      <div className="max-w-3xl mx-auto text-center" data-id="element-84">
        {/* Brand */}
        <h3 className="text-2xl md:text-3xl font-black text-white uppercase tracking-wide mb-3" data-id="element-85">
          💰 DOMINANDO SHOPIFY™
        </h3>
        <p className="text-gray-400 text-base md:text-lg mb-2" data-id="element-86">
          El programa N°1 para crear y vender productos digitales con Shopify en
          Argentina.
        </p>
        <p className="text-[#FC9DFF] italic text-sm md:text-base font-medium mb-8" data-id="element-87">
          Porque tu libertad financiera no debería costarte años de frustración.
        </p>

        {/* Contact Info */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 mb-8 text-sm md:text-base" data-id="element-88">
          <a href="mailto:soporte@brendamelisah.com" className="inline-flex items-center gap-2 text-gray-300 hover:text-[#FC9DFF] transition-colors" data-id="element-89">
            <MailIcon className="w-4 h-4" data-id="element-90" />
            soporte@brendamelisah.com
          </a>
          <span className="hidden md:inline text-gray-600" data-id="element-91">•</span>
          <a href="https://www.instagram.com/brendamelisah" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-gray-300 hover:text-[#FC9DFF] transition-colors" data-id="element-92">
            <InstagramIcon className="w-4 h-4" data-id="element-93" />
            @brendamelisah
          </a>
          <span className="hidden md:inline text-gray-600" data-id="element-94">•</span>
          <a href="https://www.instagram.com/dominandoshopify" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-gray-300 hover:text-[#FC9DFF] transition-colors" data-id="element-95">
            <InstagramIcon className="w-4 h-4" data-id="element-96" />
            @dominandoshopify
          </a>
          <span className="hidden md:inline text-gray-600" data-id="element-97">•</span>
          <a href="https://dominandoshopify.brendamelisah.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-gray-300 hover:text-[#FC9DFF] transition-colors" data-id="element-98">
            <GlobeIcon className="w-4 h-4" data-id="element-99" />
            dominandoshopify.brendamelisah.com
          </a>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 pt-6" data-id="element-100">
          <p className="text-gray-500 text-sm mb-2" data-id="element-101">
            © Dominando Shopify™ 2026 — Todos los derechos reservados.
          </p>
          <p className="text-gray-600 text-xs" data-id="element-102">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}